import "./styles.css";

const Tag = ({ 
    name, 
    onRemove 
}) => (
    <span className="tag-badge">
        <span className="tag-label">{name}</span>
        <button className="tag-remove" onClick={() => onRemove?.()}>
            &times;
        </button>
    </span>
);

export default Tag;